import * as types from '../constants/ActionTypes';
import { quickAnswerLayer } from '../constants/UtilVariables';

const initialState = {
  isLoading: false,
  error: false,
  display: true,
  answers: {
    // To Store quick answers topic list for Layer 1 and Layer 2
    layer1: [],
    layer2: [],
  },
  selected: {
    // To Store selected topic name for Layer 1 and Layer 2
    layer1: '',
    layer2: '',
  },
  isIntentUpdated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_QUICK_ANSWERS_TOPIC_TREE:
    case types.REQUEST_WEB_TREE_TOPICS:
      return { ...state, isLoading: true };
    case types.RECEIVE_QUICK_ANSWERS_TOPIC_TREE_ERROR:
    case types.RECEIVE_WEB_TREE_TOPICS_ERROR:
      return { ...state, isLoading: false, error: true };
    case types.RESPONSE_QUICK_ANSWERS_TOPIC_TREE:
      return {
        ...state,
        isLoading: false,
        error: false,
        answers: { layer1: action.payload && action.payload.topics },
      };
    case types.RECEIVE_WEB_TREE_TOPICS:
      return {
        ...state,
        isLoading: false,
        error: false,
        answers: { layer1: state.answers.layer1, layer2: action.payload },
      };
    case types.SELECT_QUICK_TOPIC:
      switch (action.payload.layer) {
        case quickAnswerLayer.layer1:
          return { ...state, selected: { layer1: action.payload.topicId } };
        case quickAnswerLayer.layer2:
          return { ...state, selected: { layer1: state.selected.layer1, layer2: action.payload.topicId } };
        default:
          return state;
      }
    case types.EMAIL_INTENT_SELECTED_NO_INTENT:
      return { ...state, isIntentUpdated: true };
    default:
      return state;
  }
}
